<template>
<div>

<div v-if="delivery">

 <!-- DOCUMENTO DI CONSEGNA -->
<doc :key="refreshDoc" v-bind:doc="doc" @update="setDoc"></doc>

<div v-if="showDocuments" class="col-4 mt-1 mb-1">
  <doc-list @update="setDataDoc" @close="showDocuments=false" :key="refreshDocList" v-bind:supplierId="order.supplierId"></doc-list>
</div>
<div v-else>
  <button @click="showDocumentsList" type="button"  class="btn btn-info _rdf  ml-1 mt-2 mb-2">
    <i style="color:black" class="fas fa-binoculars mr-2" aria-hidden="true"></i>
    LISTA DOCUMENTI DI ACQUISTO FORNITORE </button> 
</div>

<div v-if="!btn">
    <div class="d-flex justify-content-center">
      <div class="spinner-grow text-success "  style="width: 3rem; height: 3rem;" role="status">
        <span class="sr-only">Loading...</span>
    </div>
    </div> 
</div>  

<!-- TABLE -->
<div v-else class="dataTable">              
  <table class="table table-bordered table-sm" id="dataGrid">
    <thead class="thead-light">
      <tr>
        <th class="text-center"
            v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
            v-for="(key,index) in cols" :key="index">
            <span v-bind:style="{ color:  key!='COLORE' ? 'black':'blue'}">{{key}}</span>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr  v-for="(item, index1) in rows" :key="index1">
        <td v-for="(key,index2) in cols" :key="index2" >
        <div style="color : blue" v-if="key=='COLORE'" >

        <div class="form-group row">

            <div class="col-6">
                
                <h4 style="color:#9400D3"  class="text-nowrap"> 
                  <strong>{{item[key].toUpperCase()}}</strong>
                </h4>                
                <span style="color:#9370DB" class="text-nowrap">
                  <strong>
                    {{item['supplierColor']}}
                  </strong> 
                </span> 
                
                <div v-if="item['total']>0" class="form-check  mt-5"> 
                  <input  class="form-check-input" type="checkbox" :id="'defaultCheck'+ index1" v-model="item['selected']">
                    <label style="color:black" class="form-check-label text-nowrap" :for="'defaultCheck' + index1">
                      Non consegnare
                    </label>
                </div>
           
            </div>
  
        </div>
        
        </div> 
         <div v-else>

          <div  class="input-group mb-2">
          <div class="input-group-prepend">
            <div style="color:brown" class="input-group-text">Ord.</div>
            </div>
              <input  :disabled="true" style="position:relative;"    v-model = "item[key]['order_qty']" class="form-control inputClass rounded-2" type="number"  :placeholder="''" > 
          </div> 


          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div style="color:orange" class="input-group-text">Con.</div>
            </div>
            <input  style="position:relative;" :disabled="true" v-model = "item[key]['delivered_qty']" class="form-control inputClass rounded-2" type="number"  :placeholder="''" >
          </div>

          <div v-if="item[key]['order_qty'] > item[key]['delivered_qty']" class="input-group mb-2">

            

            <div class="input-group-prepend">
              <div v-bind:style="{ color:item[key]['qty'] > item[key]['order_qty'] ? 'black':'green',  borderWidth:item[key]['qty'] > item[key]['order_qty'] == 0 ? 'medium':'',  borderColor: item[key]['qty'] > item[key]['order_qty'] ? 'red':''}"   class="input-group-text">In consegna</div>
            </div>
            <input  v-on:keydown="keyHandler($event,'Num')" style="position:relative;" :disabled="item[key]['order_qty']==item[key]['delivered_qty']"   v-model = "item[key]['qty']" class="form-control inputClass rounded-2" type="number"  :placeholder="''" >
          </div>



         </div>
         
        </td>
      </tr>
    </tbody>
  </table>

<!-- Table -->
 </div>
  
  
  <div class="row ml-2">

  <div class="col-12 mr-3 ">
    <h4 style="color:black" class=" mt-2 float-right">Quantità in consegna  <span class="badge badge-info mr-3">{{total}}</span></h4>
  </div>

  </div>


  <alert-box class="mt-2 mb-2"  @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
 
  <button v-if="btn" :disabled="spinner" @click="checkOut()" class="btn btn-primary  float-right mr-4">
     <i style="color:yellow" class="fas fa-arrow-circle-right mr-2" aria-hidden="true"></i>
    PROCEDI
     <span v-if="spinner"  class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
  </button>
 

</div>

<div v-else>

  

</div>
 
</div> 
</template>

<script>

import alertBox                    from '@/components/common/AlertBox.vue';
import sizeList                    from '@/components/order/SizeList.vue';
import colorList                   from '@/components/order/ColorList.vue';
import api                         from '@/api'
import productInfo                 from '@/components/product/ProductInfo.vue';
import doc                         from '@/components/order/Document.vue';
import docList                     from '@/components/order/SupplierDocuments.vue';
import keyHandler                  from '@/components/mixins/keyHandler'


import { mapGetters }  from 'vuex';
export default {
   mixins: [keyHandler],
   components: {sizeList,colorList,alertBox,productInfo,doc,docList
     
  },
  props : ['order','productId','_doc'],
  data () {
    return {      
      
      delivery              : true,
      btn                   : true,
      refreshDocList        : 0 ,
      refreshDoc            : 100,   
      showDocuments         : false,
      rows                  : [],
      cols                  : [],
      vat                   : 0,      
      total                 : 0,
      msg                   : {
        title : '',
        body  : '',
        type  : 1        
      },
      
      //discount              : 0,
      doc                   : {},
      spinner               : false,
      discounts             : []
             
      
    }
  },

  computed: 
  {   
    
   ...mapGetters(['company']),
   
  },

  created()
  { 
    
    this.doc = this._doc
    this.getData()
  },

  watch: 
  {
        
    'rows' : 
    {
      
      deep: true,  
      handler : function(newValue) 
      {                
        this.total = 0
        for(var i = 0; i < newValue.length; i++) 
          {
            var obj = newValue[i];
            if(obj.selected == false)
            {
            Object.entries(obj).forEach(entry => 
            {
              
              let key = entry[0];
              let value = entry[1]['qty'];

              
              
              if (key != 'colorId' && key != 'COLORE' && key != 'supplierColor' && key !='selected'  && key != 'total')
              {

                this.total += Number(value)
              }
                      

            });  
            }

          }                
      }

    }
    
  
  },
      
 
  methods: 
  {
 
    
  showDocumentsList()
  {
    this.refreshDocList++
    this.showDocuments = true
  },

  setDataDoc(data)
  {

    this.showDocuments = false
    this.doc = data
    this.$emit('updateDoc',data)
    this.refreshDoc++

  },

  setDoc(data)
  {
    this.$emit('updateDoc',data)
    this.doc = data
    
  },


  async submit(items)
  {
    
    //console.log('CONTROLLO',this.doc.hasOwnProperty('collectionId'))

    if(this.doc.hasOwnProperty('collectionId')== false)
    {
      this.msg.title = 'ATTENZIONE '       
        this.msg.body = 'Collezione non valida.'
        this.msg.type = 1
        return   
    }

    /* CONTROLLA CHIAVI ANCHE SE VUOTE*/    
    if(this.doc.hasOwnProperty('typeId') && this.doc.hasOwnProperty('number') && this.doc.hasOwnProperty('date') )
    {      
      if(this.doc.number.length == 0)
      {
        this.msg.title = 'ATTENZIONE '       
        this.msg.body = 'Numero documento non valido.'
        this.msg.type = 1
        return   
      }
      if(!this.doc.date)
      {
        this.msg.title = 'ATTENZIONE '
        this.msg.body = 'Data documento non valido.'
        this.msg.type = 1
        return   
      }

    }
    else
    {
      this.msg.title = 'ATTENZIONE '
      this.msg.body = 'Documento non valido.'
      this.msg.type = 1  
      return
    }
        
    let check = await this.checkIn()
    let movementId = 0
    if(check.status == 'Err')
    {
      this.msg.title = 'ATTENZIONE '
      this.msg.body = check.data
      this.msg.type = 1  
      
      return
    }
    
    movementId = check.data
    
    const obj        = {}
    obj.companyId    = this.company.Id
    obj.movementId   = movementId
    obj.productId    = this.productId
    obj.storeId      = this.order.storeId
    obj.body         = items
    obj.discountList = this.discounts

    this.btn = false
    this.saveData(obj)
   


  },
  
  async saveData(data)
  {    
    this.spinner  = true  
    const sp      = {'sp':'spCreateWareHouseFromOrderDelivering'}
    const json    = Object.assign(data, sp);  
    await api.post(json).then(res => {    
      if(res.status==200)
        {
                    
          this.$emit('update') 

        }
        else if(res.status==500)
        {
                    
          this.msg.title = 'ATTENZIONE '
          this.msg.body = res.data
          this.msg.type = 1
          this.btn = true
          this.spinner = false

        } 
        else
        {
          

          this.msg.title = 'ATTENZIONE '
          this.msg.body = res
          this.msg.type = 1
          this.btn = true
          this.spinner = false
               
        } 
    }).catch(err => 
    {
      
      this.msg.title = 'ATTENZIONE '
      this.msg.body = err.message
      this.msg.type = 1
      this.btn = true
      this.spinner = false

    }).finally(() => {
      
      //this.spinner = false
      
    });





    
  },
  
  checkIn() 
  {
    console.log('CHECK IN ORDER ',this.doc.number)
    this.spinner = true
    const data  = {'companyId'   : this.company.Id ,
                  'storeId'      : this.order.storeId, 
                  'supplierId'   : this.order.supplierId,
                  'doc_number'   : this.doc.number,
                  'doc_date'     : this.doc.date,
                  'doc_typeId'   : this.doc.typeId,
                  'collectionId' : this.doc.collectionId}       
    
    const sp   = {'sp':'spCreateSupplierDocumentMovement'}
    const json = Object.assign(data, sp);
    return new Promise(async (resolve, reject)  =>  {
    await api.post(json).then(res => {
      if(res.status==200)
        {
          resolve({'status':'OK','data':res.data.recordsets[0][0].movementId})               
        }
        else if(res.status==500)
        {
          
          resolve({'status':'Err','data':res.data})               
          

        } 
        else
        {
          
          resolve({'status':'Err','data':res})               
          
        } 
    }).catch(err => 
    {
      
         resolve({'status':'Err','data':err.message})               
    }).finally(() => {
      this.spinner = false
    });    


  })

	},
 
    setTables()
    {
      
     
      this.show = !this.show
      this.$nextTick(function () {
        $('input:visible:enabled:first').focus(); 
      })
     
      
    },

    copyQty()
    {

    },

    setColorList(colors)
    {
      this.productColors = colors
      this.createGrid(this.productColors,this.productSizes)
      
      
    },
    setSizeList(sizes)
    {
      this.productSizes = sizes
      this.createGrid(this.productColors,this.productSizes)
      

    },

    createGrid(colors,sizes,items)
    {

      this.cols = []
      this.rows = []
      this.cols.push('COLORE')
      sizes.forEach(item =>
      {
        this.cols.push(item.size)
      }) 
             
      var arr = []
      var obj = {}
      var tmp = {}

      //console.log(items)

      colors.forEach(color => 
      {
        obj  = {}
        obj.COLORE        = color.color
        obj.colorId       = color.colorId
        obj.supplierColor = color.supplierColor
        obj.selected      = false
        obj.total         = 0
        let total         = 0
        sizes.forEach(size => 
        {   
           

          var item          = items.filter(item => (item.colorId == color.colorId && item.sizeId == size.sizeId))  
          
          if(item.length > 0)
          {
            total = total + Number(item[0].order_qty) - Number(item[0].delivered_qty)                            
            tmp = {}    
            tmp['row_Id']         = item[0].row_Id
            tmp['qty']            = Number(item[0].order_qty) - Number(item[0].delivered_qty)                            
            tmp['order_qty']      = item[0].order_qty
            tmp['costPrice']      = item[0].cost_price

            /*tmp['discount']       = item[0].discount*/
            
            tmp['delivered_qty']  = Number(item[0].delivered_qty)
            tmp['barcode']        = item[0].barcode
            tmp['sizeId']         = size.sizeId
            

            obj[size.size]        = tmp 
            
          }
            // COL NOT USED
            else
            {
        
              tmp                   = {}  
              tmp['row_Id']         = 0
              tmp['qty']            = 0
              tmp['order_qty']      = 0
              tmp['delivered_qty']  = 0
              tmp['barcode']        = ''
              tmp['sizeId']         = size.sizeId
              obj[size.size]        = tmp 
              
            }
            

        })

        obj.total= total


        

        arr.push(obj)

      })
         
    this.rows = arr
    
    

    this.$nextTick(function () {
        $('input:visible:enabled:first').focus(); 
      })            
      
      
    },

   
   checkOut() 
    {
      
      this.msg.title = ''
      if(this.total == 0)
      {
        this.msg.title = 'ATTENZIONE '  
        this.msg.body = 'Nessuna quantità Colore/Misura da consegnare.'
        this.msg.type = 1
        
        return
      }
      
    
      this.msg.title = ''
      let err = false
      this.rows.forEach(item =>{
        
        if(item.selected == false)
        {
        
        Object.entries(item).forEach(entry => 
            {
              let key = entry[0];
                            
              if (key != 'colorId' && key != 'COLORE' && key != 'supplierColor' && key != 'selected' && key != 'total')
              {
                  if( entry[1]['qty'] > entry[1]['order_qty'] - entry[1]['delivered_qty'])
                  {

                    //this.msg.title = 'ATTENZIONE '
                    //this.msg.body = 'Quantità misura [' + key + '] colore [' + item.COLORE + '] maggiore della quantità da consegnare.'
                    
                    //this.msg.type = 1
                    //err = true
                    

                    
                  }
                  
                                  
              }
                      
            });  
      
        }

      })
      
      
      // NO QUANTITY
      if(err)
      {
       return
      }
      

      let items = []
      this.rows.forEach(item =>{
        if(item.selected == false)
        {

        Object.entries(item).forEach(entry => 
            {
              let key = entry[0];
                            
              if (key != 'colorId' && key != 'COLORE' && key != 'supplierColor' && key != 'selected' && key != 'total')
              {
                  if(entry[1]['qty'] > 0)
                  {
                    items.push({'row_Id': entry[1]['row_Id'], 'barcode': entry[1]['barcode'],'qty': entry[1]['qty'],'costPrice' : entry[1]['costPrice'],'vat':this.vat,'discount':entry[1]['discount']})
                  }                
              }
                      
            });  
      
        }

      })
      
      
     
     
      // SALVA
      this.submit(items)
      

      

      
      
      
    },  
   
    
   
 
    async getData()
    {
        
        

        var data      = {'orderId' : this.order.orderId, 'productId' : this.productId}
        var sp        = {'sp' : 'spOrderDetailProductQty'}
        var json      = Object.assign(data, sp);



        await api.post(json).then(res => {
          if(res.status==200)
            {
              var sizes   = res.data.recordsets[1]  
              var colors  = res.data.recordsets[2]

              this.createGrid(colors,sizes,res.data.recordsets[0])
              this.vat =  res.data.recordsets[3][0].vat   
              this.discounts = []
              this.discounts.push({
                'discount':res.data.recordsets[0][0].discount,'order_by':1
              })
              this.discounts.push({
                'discount':res.data.recordsets[0][0].discount2,'order_by':2
              })
              this.discounts.push({
                'discount':res.data.recordsets[0][0].discount3,'order_by':3
              })      
            }
            else if(res.status==500)
            {
              console.log(res.data)

            } 
            else
            {
              console.log('Network Error.')                  
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });
        
    },



    }
  
}
</script>

<style scoped>
.form-check-label
    {
      cursor : pointer; 
    }

.form-check-input 
    {
      
      cursor : pointer; 
    }

.rdf
{
  font-family      : 'Roboto Condensed';
  background-color : rgb(227, 97, 58);
  color            : white
}
.inputClass{

  font-weight       : bold;
  
   
  }
 /* 
.misura
{
  color        : coral;
  font-size    : 12px;
}
*/
/*
input[type=text]:disabled {
  background : white;
  color      : navy
}
*/
h4 {
  font-family: 'Roboto Condensed';
  font-size: 18px;
}


.dataTable {
position: relative;
height: 400px;
overflow: auto;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   :  white;
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }

 .badge-info
 {
  font-size : 20px;
 }

</style>